export default __webpack_public_path__ + "static/media/image-green.f2632dd4.svg";